import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Accordion, Button, Card, Row, Col } from 'react-bootstrap';
import { useId } from 'react-id-generator';

// Own constants/actions/components
import { getPostalCodeAction } from 'services/actions/postal-code';
import { addNotesAction, useCrisDataAction } from 'services/actions/shopping-cart';

const PassengersInformation = (props) => {
  const {
    isGift,
    numberOfCompanion,
    datas,
    personalData,
    addressData,
    register,
    errors,
    trigger,
    indexMap,
    setFocus,
    setValue,
    clearErrors,
  } = props;
  const idNameForm = 'exp-buy-pda-psg-inf';
  const dispatch = useDispatch();
  const [idGen] = useId();
  const [isRequired, setIsRequired] = useState(true);
  const [name, setName] = useState('');
  const [lastName, setLastname] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [email, setEmail] = useState(personalData?.email || '');
  const [birthDate, setBirthDate] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [street, setStreet] = useState('');
  const [extNumber, setExtNumber] = useState('');
  const [intNumber, setIntNumber] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [colony, setColony] = useState([]);
  const [onlycolony, setOnlyColony] = useState('Colonia');
  const [municipality, setMunicipality] = useState('');
  const [colonyText, setColonyText] = useState([]);
  const [nameColonyText, setnameColonyText] = useState('colony-text');
  const [isRequiredColonyText, setIsRequiredColonyText] = useState(false);
  const [isRequiredExtNumber, setIsRequiredExtNumber] = useState(true);
  const [maxNumberOfCompanions, setMaxNumberOfCompanions] = useState(0);
  const [currentNumberOfCompanions, setCurrentNumberOfCompanions] = useState(0);
  const [companions, setCompanions] = useState([]);
  const accordionsRefs = useRef([]);

  const handleChanged = () => {
    /* eslint-disable react/prop-types */
    const colonyAndMunicipality = addressData.colony.split(',');
    dispatch(useCrisDataAction(indexMap, isRequired));
    clearErrors();
    setColony([]);
    setName(personalData.name);
    setLastname(personalData.lastName);
    setMiddleName(personalData.middleName);
    setPhoneNumber(personalData.phoneNumber);
    setBirthDate(personalData.birthDate);
    setPostalCode(addressData.postalCode);
    setState(addressData.state);
    setCity(addressData.city);
    setOnlyColony([colonyAndMunicipality[0]]);
    setMunicipality(colonyAndMunicipality[1]);
    setStreet(addressData.street);
    setExtNumber(addressData.extNumber);
    setIntNumber(addressData.intNumber ? addressData.intNumber : '');
    setIsRequiredExtNumber(!addressData.extNumber.length);

    setValue(`phoneNumber-${indexMap}`, personalData.phoneNumber, { shouldValidate: true });
    setValue(`email-${indexMap}`, personalData.email, { shouldValidate: true });

    setIsRequired(false);
  };

  const handleAddNotes = (event) => {
    dispatch(addNotesAction(indexMap, event.target.value));
  };

  const searchPostalCode = async (event) => {
    const cp = event.target.value;
    const cpNotFound = document.querySelectorAll('.cp-not-found')[0];

    if (!cp.length) {
      cpNotFound.classList.add('d-none');
    }

    if (cp.length === 5) {
      const response = await dispatch(getPostalCodeAction(cp));
      const {
        action: {
          payload: {
            data,
            status,
          },
        },
      } = response;

      if (status >= 200 && status < 300 && data.status !== false) {
        cpNotFound.classList.add('d-none');
        setState(data[0].state);
        setCity(data[0].town);
        const arrayColony = [];

        data.map((col) => {
          return arrayColony.push(col.colony);
        });
        setFocus(`state-${indexMap}`);
        setFocus(`city-${indexMap}`);
        setFocus(`colony-${indexMap}`);
        setFocus(`municipality-${indexMap}`);
        clearErrors(`state-${indexMap}`);
        clearErrors(`city-${indexMap}`);
        clearErrors(`colony-${indexMap}`);
        clearErrors(`municipality-${indexMap}`);
        setColony(arrayColony);
        setMunicipality(data[0].delegation);
      } else {
        cpNotFound.classList.remove('d-none');
      }
    }
  };

  const handleFormatDay = (event) => {
    const input = event.target;
    if (event.charCode < 47 || event.charCode > 57) {
      event.preventDefault();
    }
    const len = input.value.length;

    if (len !== 1 || len !== 3) {
      if (event.charCode === 47) {
        event.preventDefault();
      }
    }

    if (len === 2) {
      input.value += '/';
    }

    if (len === 5) {
      input.value += '/';
    }
  };

  const handleChangedBirthday = (event) => {
    handleFormatDay(event);
    setBirthDate(event.target.value);
  };

  const handleClick = (event) => {
    const elementToToggle = event.target;
    elementToToggle.classList.toggle('open');
  };

  const addCompanion = () => {
    setCurrentNumberOfCompanions(currentNumberOfCompanions + 1);

    setCompanions([
      ...companions,
      {
        id: companions.length,
        name: '',
        lastName: '',
        middleName: '',
        birthDate: '',
        email: '',
        phoneNumber: '',
      },
    ]);
  };

  const handleChangeCompanion = (e, idx) => {
    const nameKey = e.target.name.split('-')[0];

    setCompanions(
      companions.map((companion) => {
        if (companion.id !== idx) return companion;

        return {
          ...companion,
          [nameKey]: e.target.value,
        };
      }),
    );
  };

  const removeCompanion = async (id) => {
    setCurrentNumberOfCompanions(currentNumberOfCompanions - 1);

    setValue(`name-${id}-${indexMap}`, '');
    setValue(`lastName-${id}-${indexMap}`, '');
    setValue(`middleName-${id}-${indexMap}`, '');
    setValue(`birthDate-${id}-${indexMap}`, '');
    setValue(`email-${id}-${indexMap}`, '');
    setValue(`phoneNumber-${id}-${indexMap}`, '');

    setCompanions(companions.filter((companion) => companion.id !== id));
    await trigger('inputcheck');
  };

  useEffect(() => {
    if (personalData?.email) {
      setEmail(personalData.email);
    }
  }, [personalData]);

  const renderAddData = () => {
    return (
      /* eslint-disable react/jsx-props-no-spreading */
      <div className={idGen}>
        <Row>
          <Col lg={12}>
            <h3 className="text-navy-blue">
              <i className="fas fa-user mr-2" />
              Titular de reservación
            </h3>
          </Col>
          <Col lg={12}>
            <h4 className="mt-15 text-bold text-navy-blue">Datos personales</h4>
            <input
              {...register(`type-${indexMap}`)}
              name={`type-${indexMap}`}
              data-group={indexMap}
              data-name="type"
              hidden
              type="text"
              value="PRINCIPAL"
              readOnly />
            <input type="text" hidden value={datas.id} data-group={indexMap} data-name="idexp" readOnly />
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-nam-ex${indexMap}`}>Nombre(s)</label>
              <input
                {...register(`name-${indexMap}`, {
                  required: isRequired,
                  pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                  onChange: (e) => setName(e.target.value),
                })}
                id={`${idNameForm}-inp-nam-ex${indexMap}`}
                name={`name-${indexMap}`}
                data-group={indexMap}
                data-name="name"
                className="form-control psg-name-data"
                placeholder="Nombre(s)"
                type="text"
                value={name} />
              {errors[`name-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`name-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-las-nam-ex${indexMap}`}>Apellido Paterno</label>
              <input
                {...register(`lastName-${indexMap}`, {
                  required: isRequired,
                  pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                  onChange: (e) => setLastname(e.target.value),
                })}
                id={`${idNameForm}-inp-las-nam-ex${indexMap}`}
                name={`lastName-${indexMap}`}
                data-group={indexMap}
                data-name="lastName"
                className="form-control psg-lastname-data"
                placeholder="Apellido Paterno"
                type="text"
                value={lastName} />
              {errors[`lastName-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`lastName-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-mid-nam-ex${indexMap}`}>Apellido Materno</label>
              <input
                {...register(`middleName-${indexMap}`, {
                  pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                  onChange: (e) => setMiddleName(e.target.value),
                })}
                id={`${idNameForm}-inp-mid-nam-ex${indexMap}`}
                name={`middleName-${indexMap}`}
                data-group={indexMap}
                data-name="middleName"
                className="form-control psg-middlename-data"
                placeholder="Apellido Materno"
                type="text"
                value={middleName} />
              {errors[`middleName-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-bth-ex${indexMap}`}>Fecha de nacimiento</label>
              <input
                {...register(`birthDate-${indexMap}`, {
                  required: isRequired,
                  pattern: /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/,
                  onChange: handleChangedBirthday,
                })}
                id={`${idNameForm}-inp-bth-ex${indexMap}`}
                name={`birthDate-${indexMap}`}
                data-group={indexMap}
                data-name="birthDate"
                className="form-control"
                placeholder="dd/mm/yyyy"
                type="text"
                value={birthDate} />
              {errors[`birthDate-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`birthDate-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* Fecha no valida</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-eml-ex${indexMap}`}>Correo electrónico</label>
              <input
                id={`${idNameForm}-inp-eml-ex${indexMap}`}
                name={`email-${indexMap}`}
                data-group={indexMap}
                data-name="email"
                className="form-control psg-email-data"
                placeholder="Correo electrónico"
                type="email"
                readOnly
                value={email} />
              {errors[`email-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`email-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* Correo electrónico no valido</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-pho-ex${indexMap}`}>Teléfono celular</label>
              <input
                {...register(`phoneNumber-${indexMap}`, {
                  required: isRequired,
                  validate: {
                    number: (value) => /^[0-9]{10}$/.test(value),
                    startedZero: (value) => /^[1-9a-zA-Z][0-9a-zA-Z]*$/.test(value),
                  },
                  onChange: (e) => setPhoneNumber(e.target.value),
                })}
                id={`${idNameForm}-inp-pho-ex${indexMap}`}
                name={`phoneNumber-${indexMap}`}
                data-group={indexMap}
                data-name="phoneNumber"
                className="form-control psg-phoneNumber-data"
                placeholder="Teléfono celular"
                type="text"
                value={phoneNumber} />
              {errors[`phoneNumber-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`phoneNumber-${indexMap}`]?.type === 'number' && <small className="error-msg">* Solo 10 dígitos</small>}
              {errors[`phoneNumber-${indexMap}`]?.type === 'startedZero' && <small className="error-msg">* No debe comenzar con 0</small>}
            </div>
          </Col>
          <Col lg={12}>
            <h4 className="mt-15 text-bold">Dirección</h4>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-cpx-ex${indexMap}`}>Código postal</label>
              <input
                {...register(`cp-${indexMap}`, {
                  required: isRequired,
                  onChange: (e) => {
                    setIsRequired(true);
                    if (e.target.value.length <= 5) {
                      setPostalCode(e.target.value);
                    } else {
                      e.preventDefault();
                    }
                  },
                })}
                id={`${idNameForm}-inp-cpx-ex${indexMap}`}
                name={`cp-${indexMap}`}
                data-group={indexMap}
                data-address={indexMap}
                data-name="cp"
                className="form-control psg-postalCode-data"
                placeholder="Código postal"
                type="number"
                value={postalCode}
                onKeyUp={searchPostalCode} />
              {errors[`cp-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              <small className="error-msg d-none cp-not-found">* El código postal no se encuentra registrado</small>
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-sta-ex${indexMap}`}>Estado</label>
              <input
                {...register(`state-${indexMap}`, {
                  required: isRequired,
                  pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                  onChange: (e) => setState(e.target.value),
                })}
                id={`${idNameForm}-inp-sta-ex${indexMap}`}
                name={`state-${indexMap}`}
                data-group={indexMap}
                data-address={indexMap}
                data-name="state"
                className="form-control psg-state-data"
                placeholder="Estado"
                type="text"
                value={state} />
              {errors[`state-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`state-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-cit-ex${indexMap}`}>Ciudad</label>
              <input
                {...register(`city-${indexMap}`, {
                  required: isRequired,
                  pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                  onChange: (e) => setCity(e.target.value),
                })}
                id={`${idNameForm}-inp-cit-ex${indexMap}`}
                name={`city-${indexMap}`}
                data-group={indexMap}
                data-address={indexMap}
                data-name="city"
                className="form-control psg-city-data"
                placeholder="Ciudad"
                type="text"
                value={city} />
              {errors[`city-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`city-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-mun-ex${indexMap}`}>Municipio o Delegación</label>
              <input
                {...register(`municipality-${indexMap}`, {
                  required: isRequired,
                  pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                  onChange: (e) => setMunicipality(e.target.value),
                })}
                id={`${idNameForm}-inp-mun-ex${indexMap}`}
                name={`municipality-${indexMap}`}
                data-group={indexMap}
                data-address={indexMap}
                data-name="municipality"
                className="form-control psg-municipality-data"
                placeholder="Municipio o Delegación"
                type="text"
                value={municipality} />
              {errors[`municipality-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`municipality-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-col-ex${indexMap}`}>Colonia</label>
              <div className="custom-select-cp">
                <select
                  {...register(`colony-${indexMap}`, {
                    required: isRequired,
                    onChange: (e) => {
                      if (e.target.value === 'otra') {
                        setnameColonyText('colony');
                        setIsRequiredColonyText(true);
                      } else {
                        setnameColonyText('colony-text');
                        setIsRequiredColonyText(false);
                      }
                    },
                  })}
                  id={`${idNameForm}-inp-col-ex${indexMap}`}
                  name={`colony-${indexMap}`}
                  data-address={indexMap}
                  data-group={indexMap}
                  data-name="colony"
                  className="custom-select psg-colony-data"
                  defaultValue="DEFAULT">
                  {
                    isRequired ? (
                      <option value="" defaultValue>Colonia</option>
                    ) : <option value={onlycolony} defaultValue>{onlycolony}</option>
                  }
                  {
                    /* eslint-disable */
                    colony.map((col, index) => <option value={col} key={index}>{col}</option>)
                  }
                  <option value="otra">Otra</option>
                </select>
              </div>
              {errors[`colony-${indexMap}`] && <small className="error-msg">* Campo requerido</small>}
            </div>
          </Col>
          <Col lg={6} className={isRequiredColonyText ? '' : 'd-none'}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-col-inp-ex${indexMap}`}>Ingresa la Colonia</label>
              <input
                {...register(`colony-input-${indexMap}`, {
                  required: isRequiredColonyText,
                  pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                  onChange: (e) => setColonyText(e.target.value),
                })}
                id={`${idNameForm}-inp-col-inp-ex${indexMap}`}
                name={`colony-input-${indexMap}`}
                data-group={indexMap}
                data-address={indexMap}
                data-name={nameColonyText}
                className="form-control psg-colony-input-data"
                placeholder="Ingresa la Colonia"
                type="text"
                value={colonyText} />
              {errors[`colony-input-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`colony-input-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-add-ex${indexMap}`}>Calle</label>
              <input
                {...register(`street-${indexMap}`, {
                  required: isRequired,
                  pattern: /^[a-zA-Z0-9 . *(a-zA-ZÀ-ÖØ-öø-ÿ*)*]+$/,
                  onChange: (e) => setStreet(e.target.value),
                })}
                id={`${idNameForm}-inp-add-ex${indexMap}`}
                name={`street-${indexMap}`}
                data-group={indexMap}
                data-address={indexMap}
                data-name="street"
                className="form-control psg-street-data"
                placeholder="Calle"
                type="text"
                value={street} />
              {errors[`street-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`street-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-num-ext-ex${indexMap}`}>No. Exterior</label>
              <input
                {...register(`extNumber-${indexMap}`, {
                  required: isRequiredExtNumber,
                  pattern: /^[a-zA-Z\-0-9]+$/,
                  onChange: (e) => setExtNumber(e.target.value),
                })}
                id={`${idNameForm}-inp-num-ext-ex${indexMap}`}
                name={`extNumber-${indexMap}`}
                data-group={indexMap}
                data-address={indexMap}
                data-name="extNumber"
                className="form-control psg-extNumber-data"
                placeholder="No. Exterior"
                type="text"
                value={extNumber} />
              {errors[`extNumber-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors[`extNumber-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-group pr-15">
              <label htmlFor={`${idNameForm}-inp-num-int-ex${indexMap}`}>No. Interior</label>
              <input
                {...register(`intNumber-${indexMap}`, {
                  onChange: (e) => setIntNumber(e.target.value),
                  pattern: /^[a-zA-Z\-0-9]+$/,
                })}
                id={`${idNameForm}-inp-num-int-ex${indexMap}`}
                name={`intNumber-${indexMap}`}
                data-group={indexMap}
                data-address={indexMap}
                data-name="intNumber"
                className="form-control psg-intNumber-data"
                placeholder="No. Interior"
                type="text"
                value={intNumber} />
              {errors[`intNumber-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
            </div>
          </Col>
        </Row>

        {
          currentNumberOfCompanions < maxNumberOfCompanions && (
            <Row>
              <Col lg={6}>
                <div className="d-flex text-fiord mb-15">
                  <div className="br-rounded-left-fiord pl-3 pr-2 pb-2 pt-3 p-md-2 flex-grow-7 d-flex align-items-center">
                    <i className="fas fa-user mr-2" />
                    <span className="ft-12">
                      {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                      Agregar acompañante ({currentNumberOfCompanions}/{maxNumberOfCompanions})
                    </span>
                  </div>
                  <div className="flex-grow-3">
                    <button
                      type="button"
                      className="btn bg-fiord btn-min-secondary br-rounded-right"
                      onClick={addCompanion}>
                      <i className="fas fa-plus" />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          )
        }

        {
          maxNumberOfCompanions !== 0 && currentNumberOfCompanions === maxNumberOfCompanions && (
            <Row>
              <Col lg={6}>
                <div className="d-flex text-fiord mb-15">
                  <div className="br-rounded-fiord p-10">
                    <i className="fas fa-user mr-2" />
                    <span className="ft-12">
                      {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                      Mis acompañantes ({currentNumberOfCompanions}/{maxNumberOfCompanions})
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          )
        }

        <Accordion className="text-left collapse show pr-15">
          {
            companions.map((companion, idx) => {
              return (
                <Card className="no-border-x mb-3 border-bottom companion" key={idx}>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    ref={(el) => (accordionsRefs.current[idx] = el)}
                    eventKey={`${idx}`}
                    className="p-15 text-left not-link d-flex"
                    onClick={handleClick}>
                    <h3 className="mb-0">
                      Acompañante
                      <span className="ml-1">{idx + 1}</span>
                    </h3>
                    <i
                      className="fas fa-trash-alt text-gray-chateau ml-3"
                      onClick={() => removeCompanion(companion.id)} />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={`${idx}`}>
                    <Card.Body className="py-0 px-15">
                      <Row>
                        <Col lg={12}>
                          <input
                            {...register(`type-${idx}-${indexMap}`)}
                            name={`type-${idx}-${indexMap}`}
                            data-group={indexMap}
                            data-name={`type-${indexMap}`}
                            data-companion={idx}
                            hidden
                            type="text"
                            value="SECONDARY" />
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-nam-ex${indexMap}`}>Nombre(s)</label>
                            <input
                              {...register(`name-${idx}-${indexMap}`, {
                                required: true,
                                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                                onChange: (e) => handleChangeCompanion(e, idx),
                              })}
                              id={`${idNameForm}-inp-${idx}-nam-ex${indexMap}`}
                              name={`name-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`name-${indexMap}`}
                              data-companion={idx}
                              className="form-control"
                              placeholder="Nombre(s)"
                              type="text"
                              value={companion.name} />
                            {errors[`name-${idx}-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
                            {errors[`name-${idx}-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-las-ex${indexMap}`}>Apellido Paterno</label>
                            <input
                              {...register(`lastName-${idx}-${indexMap}`, {
                                required: true,
                                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                                onChange: (e) => handleChangeCompanion(e, idx),
                              })}
                              id={`${idNameForm}-inp-${idx}-las-ex${indexMap}`}
                              name={`lastName-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`lastName-${indexMap}`}
                              data-companion={idx}
                              className="form-control"
                              placeholder="Apellido Paterno"
                              type="text"
                              value={companion.lastName} />
                            {errors[`lastName-${idx}-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
                            {errors[`lastName-${idx}-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-mid-ex${indexMap}`}>Apellido Materno</label>
                            <input
                              {...register(`middleName-${idx}-${indexMap}`, {
                                pattern: /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g,
                                onChange: (e) => handleChangeCompanion(e, idx),
                              })}
                              id={`${idNameForm}-inp-${idx}-mid-ex${indexMap}`}
                              name={`middleName-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`middleName-${indexMap}`}
                              data-companion={idx}
                              className="form-control"
                              placeholder="Apellido Materno"
                              type="text"
                              value={companion.middleName} />
                            {errors[`middleName-${idx}-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* No caracteres especiales</small>}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-bth-ex${indexMap}`}>Fecha de nacimiento</label>
                            <input
                              {...register(`birthDate-${idx}-${indexMap}`, {
                                required: true,
                                pattern: /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/,
                                onChange: (e) => {
                                  handleFormatDay(e);
                                  handleChangeCompanion(e, idx);
                                },
                              })}
                              id={`${idNameForm}-inp-${idx}-bth-ex${indexMap}`}
                              name={`birthDate-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`birthDate-${indexMap}`}
                              data-companion={idx}
                              className="form-control"
                              placeholder="dd/mm/yyyy"
                              type="text"
                              value={companion.birthDate} />
                            {errors[`birthDate-${idx}-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
                            {errors[`birthDate-${idx}-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* Fecha no valida</small>}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-eml-ex${indexMap}`}>Correo electrónico</label>
                            <input
                              {...register(`email-${idx}-${indexMap}`, {
                                required: true,
                                pattern: /^[a-zA-Z0-9-._]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,
                                onChange: (e) => handleChangeCompanion(e, idx),
                              })}
                              id={`${idNameForm}-inp-${idx}-eml-ex${indexMap}`}
                              name={`email-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`email-${indexMap}`}
                              data-companion={idx}
                              className="form-control"
                              placeholder="Correo electrónico"
                              type="email"
                              value={companion.email} />
                            {errors[`email-${idx}-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
                            {errors[`email-${idx}-${indexMap}`]?.type === 'pattern' && <small className="error-msg">* Correo electrónico no valido</small>}
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group pr-15">
                            <label htmlFor={`${idNameForm}-inp-${idx}-pho-ex${indexMap}`}>Teléfono celular</label>
                            <input
                              {...register(`phoneNumber-${idx}-${indexMap}`, {
                                required: isRequired,
                                validate: {
                                  number: (value) => /^[0-9]{10}$/.test(value),
                                  startedZero: (value) => /^[1-9a-zA-Z][0-9a-zA-Z]*$/.test(value),
                                },
                                onChange: (e) => handleChangeCompanion(e, idx),
                              })}
                              id={`${idNameForm}-inp-${idx}-pho-ex${indexMap}`}
                              name={`phoneNumber-${idx}-${indexMap}`}
                              data-group={indexMap}
                              data-name={`phoneNumber-${indexMap}`}
                              data-companion={idx}
                              className="form-control"
                              placeholder="Teléfono celular"
                              type="text"
                              value={companion.phoneNumber} />
                            {errors[`phoneNumber-${idx}-${indexMap}`]?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
                            {errors[`phoneNumber-${idx}-${indexMap}`]?.type === 'number' && <small className="error-msg">* Solo 10 dígitos</small>}
                            {errors[`phoneNumber-${idx}-${indexMap}`]?.type === 'startedZero' && <small className="error-msg">* No debe comenzar con 0</small>}
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )
            })
          }
        </Accordion>
      </div>
    );
  };

  useEffect(() => {
    setMaxNumberOfCompanions(numberOfCompanion);
  }, []);

  useEffect(() => {
    accordionsRefs.current.map((accordion) => {
      if (accordion) {
        accordion.click();
      }
    })
  }, [currentNumberOfCompanions]);

  return (
    <>
      <div className="shopping-card-info my-30" data-id={datas.id} data-key={idGen}>
        <Row>
          <Col lg={4}>
            <img
              src={datas.image}
              alt="card-exp"
              className="w-100 p-15" />
          </Col>
          <Col lg={8} className="text-left px-30 px-lg-15">
            <h3 className="py-15">{datas.title}</h3>
            <div className="custom-control custom-radio">
              <input
                id={`${idNameForm}-rdi-use-adr-${idGen}`}
                type="radio"
                name={`useCrisData-${indexMap}`}
                data-group={indexMap}
                data-name="useCrisData"
                className="custom-control-input"
                value={true}
                checked={!isRequired}
                onChange={handleChanged} />
              <label className="custom-control-label" htmlFor={`${idNameForm}-rdi-use-adr-${idGen}`}>
                Utilizar los datos registrados en Aeroméxico Rewards
              </label>
            </div>
            <div className="use-form-container">
              {renderAddData()}
            </div>
            <div className="add-form-container d-none" />
            {
              isGift === true
                ? (
                  <div className="custom-control custom-control-area custom-input-area">
                    <label htmlFor="notes">Escribe una nota</label>
                    <textarea
                      id={`${idNameForm}-txa-add-fom-${idGen}`}
                      data-key={indexMap}
                      name="notes"
                      rows="4"
                      placeholder="Agrega un mensaje (opcional)"
                      onChange={handleAddNotes} />
                  </div>
                ) : ''
            }
          </Col>
          {
            isGift === true
              ? (
                <Col lg={12}>
                  <div className="text-left gift-label">
                    <i className="fas fa-gift mr-2 text-white" />
                    <span>Esta Experiencia es un regalo</span>
                  </div>
                </Col>
              ) : ''
          }
          {
            datas.stock !== null && datas.stock < 5 ? (
              <Col lg={12}>
                <div className="text-left stock-label">
                  <i className="fas fa-exclamation-triangle mr-2" />
                  <span>Quedan muy pocas Experiencias. ¡Date prisa!</span>
                </div>
              </Col>
            ) : ''
          }
        </Row>
      </div>
    </>
  );
};

PassengersInformation.defaultProps = {
  personalData: {},
};


PassengersInformation.propTypes = {
  isGift: PropTypes.bool.isRequired,
  numberOfCompanion: PropTypes.number.isRequired,
  datas: PropTypes.object.isRequired,
  personalData: PropTypes.object,
  addressData: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  trigger: PropTypes.func.isRequired,
  indexMap: PropTypes.number.isRequired,
  setFocus: PropTypes.func.isRequired,
  setValue: PropTypes.func,
  clearErrors: PropTypes.func.isRequired,
};

export default PassengersInformation;
